import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWorkspaceCreditTransaction } from '@shared/dto/+workspace/workspace_credit_transaction/dto_workspace_credit_transaction';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWorkspaceBilling } from './state_workspace_billing';

export const local_workspace_billing_credits_transactions_upsert = (
  payload: DTOWorkspaceCreditTransaction[],
): PayloadAction<DTOWorkspaceCreditTransaction[]> => ({
  type: ENUM__redux_action.WORKSPACE_BILLING_CREDITS_TRANSACTIONS_UPSERT,
  payload: payload,
});

export const init_local_workspace_billing_credits_transactions_upsert = (
  state: StateWorkspaceBilling,
  action: PayloadAction<DTOWorkspaceCreditTransaction[]>,
) => {
  if (action.payload.is_empty()) return;

  for (let item of action.payload) {
    let workspace_transactions_map = state.credit_transactions_map.get_or_create_map(item.workspace_id);

    workspace_transactions_map.set(item._id, item);
  }

  //need to force a re-render
  state.credit_transactions_map = new Map(state.credit_transactions_map);
};
